import React, { useState } from 'react';
import DataTable from 'components/DataTable';
import PageWrapper from 'components/PageWrapper';
import { useTableDataWithPost } from '../../hooks/useTableWithPost';
import { ProviderManagerData } from '../../config/tableConfigs';
import PageWrapperForm from 'components/PageWrapperForm';
import ProviderFormModal from './components/providerFormModal'; // ✅ fixed
import DeleteModal from 'components/DeleteModal';
import { useSession } from 'hooks/useSession';

const ProviderManagerPage = () => {
  const [modalShow, setModalShow] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedUser, setSelectedUser] = useState(null);
  const [refresh, setRefresh] = useState(0);
  const {userid} = useSession();
  const handleAddUser = () => {
    setModalMode("add");
    setSelectedUser(null);
    setModalShow(true);
  };

  const formdata = new FormData();
  formdata.append("action", "GET");
  formdata.append("userid",userid);

  const tableData = useTableDataWithPost(
    "https://pro.mokshiq.in/provider_manager_action",
    ProviderManagerData,
    formdata,
    refresh 
  );

  const handleView = (report) => {
    console.log("Viewing report:", report);
  };

  const handleEditUser = (user) => {
    setModalMode("edit");
    setSelectedUser(user);
    setModalShow(true);
  };

  const handleDelete = (user) => {
    setSelectedUser(user);
    setTimeout(() => {
      const modalEl = document.getElementById("deleteProvider1");
      if (modalEl) {
        const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    }, 100);
  };

  const handleExport = (selectedIds) => {
    console.log("Exporting selected data:", selectedIds);
    alert(`Exporting ${selectedIds.length} selected records`);
  };

  const handleDeleteSelected = (selectedIds) => {
    if (
      window.confirm(`Are you sure you want to delete ${selectedIds.length} records?`)
    ) {
      console.log("Deleting selected records:", selectedIds);
    }
  };
  const handleFormSuccess = () => {
    debugger
    console.log("handleFormSuccess called - refreshing data..."); // ✅ Debug log
    setRefresh((prev) => prev + 1);
    setModalShow(false)
  };

  // ✅ Handle successful deletion
  const handleDeleteSuccess = () => {
    console.log("Scheme deleted successfully, refreshing data...");
    setRefresh((prev) => prev + 1);
  };

  return (
    <div>
      <PageWrapperForm config={ProviderManagerData} handleOnclick={handleAddUser} buttonTitle={"Add Provider"}>
        <DataTable
          config={ProviderManagerData}
          tableData={tableData}
          onView={handleView}
          onEdit={handleEditUser}
          onDelete={handleDelete}
          onExport={handleExport}
          onDeleteSelected={handleDeleteSelected}
        />
      </PageWrapperForm>

      {/* ✅ Fixed modal usage */}
      <ProviderFormModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        mode={modalMode}
        userData={selectedUser}
        onSuccess={handleFormSuccess}
      />

      <DeleteModal
      deleteid={selectedUser}
        id="deleteProvider1"
        title="Delete Provider"
        message="Are you sure you want to delete this Provider?"
        apiUrl="https://pro.mokshiq.in/provider_manager_action"
        onSuccess={handleDeleteSuccess}
      />
    </div>
  );
};

export default ProviderManagerPage;
